import React from 'react';
import { useTranslation } from 'react-i18next';
import { Empty } from 'antd';
import styled from 'styled-components';
import { EyeInvisibleOutlined } from '@ant-design/icons';

const StyledEmpty = styled(Empty)`
  padding-top: 40px;
  
  .ant {
    &-empty {
      &-image {
        height: 50px;
      }
      &-description {
        font-size: 16px;
      }
    }
    &icon {
    font-size: 50px;
    }
  }
`;

const NoAccessGrantedComponent = () => {
  const { t } = useTranslation();
  return (
    <StyledEmpty
      description={t('COMMON.NO_ACCESS')}
      image={<EyeInvisibleOutlined />}
    />
  );
};

export default NoAccessGrantedComponent;
